import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import workspaceEngine from '../../../WorkspaceEngine/WorkspaceEngine';
import WorkspaceTabBuilder from '../../../WorkspaceEngine/WorkspaceTabBuilder';
import tabEngine from '../../../TabEngine/TabEngine';
import commandEngine from './CommandEngine';
import { CMD_WORKSPACE_CTRL_REGISTRY_KEY, META_TYPE, META_VER, WSC_TARGET } from './workspaceCtrlCommandRegisteryType';

/**
 * Registers the /ws command with the CommandEngine.
 * /ws               — opens the workspace control card
 * /ws new <name>    — creates an empty workspace and switches to it
 * /ws saveas <name> — saves current layout as new workspace and switches to it
 * /ws load <name>   — switches to a workspace (case-insensitive)
 * /ws rename <name> — renames the active workspace
 */
export function registerWorkspaceCommand() {
    commandEngine.register('/ws', {
        hint: '[new|saveas|load|rename <name>] — workspaces, no params opens the control card',
        params: [], // with params Enter selects a hint instead of executing bare /ws
        handler: ([action, ...rest]) => {
            const name = rest.join(' ').trim();
            if (action === 'new' && name) return workspaceEngine.createBlank(name);
            if (action === 'saveas' && name) return workspaceEngine.saveAs(name);
            if (action === 'rename' && name) return workspaceEngine.rename(workspaceEngine.getActiveRk(), name);
            if (action === 'load' && name) return loadByName(name);
            cardPainterManager.openCard(CMD_WORKSPACE_CTRL_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: WSC_TARGET });
        },
    });
}

function loadByName(name) {
    const ws = workspaceEngine.getAll().find((w) => w.name.toLowerCase() === name.toLowerCase());
    if (ws) tabEngine.setTabById(WorkspaceTabBuilder.toTabId(ws.rk));
}
